type IsPresentationTemplatesTopLevelEmptyStateArgs = {
    dataLength: number;
    searchQuery?: string;
    selectedTag: string;
    selectedFolderId?: string | null;
    folderId?: string;
    hasPresentationTemplateFolders: boolean;
};

const TAG_FILTER_ALL = "__all__";

export function isPresentationTemplatesTopLevelEmptyState({
    dataLength,
    searchQuery = "",
    selectedTag,
    selectedFolderId = null,
    folderId,
    hasPresentationTemplateFolders,
}: IsPresentationTemplatesTopLevelEmptyStateArgs) {
    return dataLength === 0 &&
        !searchQuery &&
        selectedTag === TAG_FILTER_ALL &&
        !selectedFolderId &&
        !folderId &&
        !hasPresentationTemplateFolders;
}
